"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _iconExternalLink = _interopRequireDefault(require("../../../shared/icons/icon-external-link.svg"));

var _Link = _interopRequireDefault(require("../../../shared/components/Link/Link"));

var _linkHelper2 = _interopRequireDefault(require("../../../shared/helpers/linkHelper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var WithExternalLinkIcon = function HyperLinkWithExternalLinkIcon(_ref) {
  var element = _ref.element,
      children = _ref.children,
      baseClass = _ref.baseClass,
      currentClass = _ref.currentClass;

  var _linkHelper = (0, _linkHelper2["default"])(element.data.url, element.data.target === '_blank'),
      cleanHref = _linkHelper.cleanHref,
      openNewTab = _linkHelper.openNewTab;

  return /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    href: cleanHref,
    className: currentClass,
    external: openNewTab
  }, children, "\xA0", openNewTab && /*#__PURE__*/_react["default"].createElement(_iconExternalLink["default"], {
    className: "".concat(baseClass, "__link-icon")
  }));
};

WithExternalLinkIcon.propTypes = {
  element: _propTypes["default"].shape({}).isRequired,
  children: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  currentClass: _propTypes["default"].string.isRequired,
  baseClass: _propTypes["default"].string.isRequired
};
var _default = WithExternalLinkIcon;
exports["default"] = _default;